import React, { useState, useEffect } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.fade-in').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  const contactInfo = [
    {
      icon: '📍',
      title: 'Visit Us',
      details: ['Shop No. 12, Main Market', 'Near City Center, Delhi - 110001']
    },
    {
      icon: '📞',
      title: 'Call Us',
      details: ['+91 98765 43210', '+91 11 2345 6789']
    },
    {
      icon: '✉️',
      title: 'Email Us',
      details: ['hello@kittodikulfi.com', 'orders@kittodikulfi.com']
    },
    {
      icon: '⏰',
      title: 'Opening Hours',
      details: ['Mon - Sun: 11:00 AM - 11:00 PM', 'Open all days!']
    }
  ];

  const faqs = [
    {
      question: 'Do you offer home delivery?',
      answer: 'Yes! We deliver within a 10km radius. Orders above ₹500 get free delivery.'
    },
    {
      question: 'Can I order for parties/events?',
      answer: 'Absolutely! We offer special bulk order discounts and custom arrangements for parties, weddings, and corporate events.'
    },
    {
      question: 'Are your products vegetarian?',
      answer: 'Yes, all our kulfi and ice cream products are 100% vegetarian and made with fresh dairy.'
    },
    {
      question: 'Do you have sugar-free options?',
      answer: 'Yes, we have a select range of sugar-free ice creams. Please ask our staff for available flavors.'
    }
  ];

  return (
    <>
      {/* Contact Hero */}
      <section className="about-hero" style={{ minHeight: '45vh' }}>
        <div className="container">
          <div style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto' }}>
            <h1 className="gradient-text" style={{ fontSize: '3.5rem', marginBottom: '20px' }}>
              Get in Touch
            </h1>
            <p style={{ fontSize: '1.2rem', opacity: 0.8 }}>
              Have questions? Want to place a bulk order? Or just want to say hi? 
              We'd love to hear from you!
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="section" style={{ background: 'white', paddingTop: '60px' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '25px',
            marginBottom: '60px'
          }}>
            {contactInfo.map((info, index) => (
              <div 
                key={index}
                className="fade-in"
                style={{
                  background: 'var(--cream)',
                  padding: '30px',
                  borderRadius: '20px',
                  textAlign: 'center',
                  transition: 'var(--transition-smooth)'
                }}
              >
                <span style={{ 
                  fontSize: '3rem', 
                  display: 'block', 
                  marginBottom: '15px' 
                }}>
                  {info.icon}
                </span>
                <h3 style={{ marginBottom: '10px', color: 'var(--chocolate)' }}>
                  {info.title}
                </h3>
                {info.details.map((detail, i) => (
                  <p key={i} style={{ opacity: 0.8, fontSize: '0.95rem' }}>
                    {detail}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form & Map */}
      <section className="section contact-section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Info */}
            <div className="contact-info fade-in">
              <h2>Let's Connect! 🍦</h2>
              <p>
                Whether you have a question about our menu, want to discuss a bulk order, 
                or just want to share your Kitto Di Kulfi experience - we're all ears!
              </p>
              
              <div style={{ marginTop: '30px' }}>
                <h3 style={{ marginBottom: '20px' }}>Follow Us</h3>
                <div className="footer-social">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
                    📘
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                    📸
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                    🐦
                  </a>
                  <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-link">
                    📺
                  </a>
                </div>
              </div>

              <div style={{ 
                marginTop: '40px',
                padding: '25px',
                background: 'rgba(255,255,255,0.1)',
                borderRadius: '15px'
              }}>
                <h4 style={{ marginBottom: '10px' }}>🎉 Special Offers</h4>
                <p style={{ fontSize: '0.95rem', opacity: 0.9 }}>
                  Follow us on Instagram and tag us in your posts for a chance to win 
                  free kulfi vouchers every week!
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form fade-in">
              {submitted ? (
                <div style={{
                  textAlign: 'center',
                  padding: '50px 20px'
                }}>
                  <span style={{ fontSize: '4rem', display: 'block', marginBottom: '20px' }}>
                    ✅
                  </span>
                  <h3 style={{ marginBottom: '15px' }}>Thank You!</h3>
                  <p style={{ opacity: 0.8 }}>
                    We've received your message and will get back to you soon!
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                    <div className="form-group">
                      <label>Your Name</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="John Doe"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Email Address</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="john@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                    <div className="form-group">
                      <label>Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="+91 98765 43210"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label>Subject</label>
                      <input
                        type="text"
                        name="subject"
                        placeholder="Bulk Order Inquiry"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Your Message</label>
                    <textarea
                      name="message"
                      placeholder="Tell us what's on your mind..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Send Message 📨
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="section" style={{ background: 'white', paddingTop: '40px' }}>
        <div className="container">
          <div className="section-header fade-in">
            <h2 className="gradient-text">Find Us Here</h2>
            <p>Come visit our parlour for the full Kitto Di Kulfi experience!</p>
          </div>
          
          <div className="fade-in" style={{
            width: '100%',
            height: '400px',
            borderRadius: '25px',
            overflow: 'hidden',
            boxShadow: 'var(--shadow-medium)'
          }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224345.83923192776!2d77.06889754725782!3d28.52758200617607!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd5b347eb62d%3A0x52c2b7494e204dce!2sNew%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1703583891234!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Kitto Di Kulfi Location"
            />
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section" style={{ background: 'var(--cream)' }}>
        <div className="container">
          <div className="section-header fade-in">
            <h2 className="gradient-text">Frequently Asked Questions</h2>
            <p>Got questions? We've got answers!</p>
          </div>
          
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            {faqs.map((faq, index) => (
              <div 
                key={index}
                className="fade-in"
                style={{
                  background: 'white',
                  padding: '25px 30px',
                  borderRadius: '15px',
                  marginBottom: '15px',
                  boxShadow: 'var(--shadow-soft)'
                }}
              >
                <h4 style={{ 
                  color: 'var(--pink-primary)', 
                  marginBottom: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}>
                  <span>❓</span> {faq.question}
                </h4>
                <p style={{ opacity: 0.8, paddingLeft: '30px' }}>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section features-section" style={{ padding: '60px 0' }}>
        <div className="container">
          <div className="fade-in" style={{ textAlign: 'center' }}>
            <h2 style={{ fontSize: '2rem', marginBottom: '15px' }}>
              Can't Wait? Call Us Now! 📞
            </h2>
            <a 
              href="tel:+919876543210" 
              className="btn" 
              style={{ 
                background: 'white', 
                color: 'var(--pink-primary)',
                fontSize: '1.3rem',
                padding: '18px 40px'
              }}
            >
              +91 98765 43210
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
